import bg from 'assets/images/margin-onboarding-1.png'
import { CeruleanButton } from 'components/Button'
import I18n from 'components/I18n'
import messages from 'lang'
import React from 'react'
import styled from 'styled-components'
import { color } from 'utils'

import { Content, Footer, Wrapper } from './styles'

type WelcomeModalProps = {
  kycNeeded?: boolean
  onClose: () => void
}

const List = styled.ol`
  list-style-type: none;
  padding: 0;
`
const ListItem = styled.li`
  display: grid;
  margin-bottom: 2rem;
  grid-template-columns: 3rem 1fr;
  grid-template-areas:
    'num title'
    'num description';
`
const Num = styled.small`
  grid-area: num;
  justify-self: center;
  background: ${color('dark600')};
  border-radius: 1rem;
  color: ${color('primaryMuted')};
  font-weight: 600;
  font-size: 1rem;
  line-height: 150%;
  width: 1.5rem;
  height: 1.5rem;
  text-align: center;
`
const ItemTitle = styled.h2`
  grid-area: title;
  margin: 0;
  font-weight: 600;
  font-size: 1rem;
  line-height: 150%;
`
const ItemDesc = styled.p`
  grid-area: description;
  margin: 0.25rem 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`
const WelcomeModal = ({ kycNeeded, onClose }: WelcomeModalProps) => (
  <Wrapper onClose={onClose}>
    <img src={bg} />
    <Content>
      <h1>
        <I18n data={messages.welcome_title} />
      </h1>
      {kycNeeded ? (
        <List>
          <ListItem>
            <Num>1</Num>
            <ItemTitle>
              <I18n data={messages.welcome_1_kyc_needed_title} />
            </ItemTitle>
            <ItemDesc>
              <I18n data={messages.welcome_1_kyc_needed_subtitle} />
            </ItemDesc>
          </ListItem>
          <ListItem>
            <Num>2</Num>
            <ItemTitle>
              <I18n data={messages.welcome_1_title} />
            </ItemTitle>
            <ItemDesc>
              <I18n data={messages.welcome_1_subtitle} />
            </ItemDesc>
          </ListItem>
          <ListItem>
            <Num>3</Num>
            <ItemTitle>
              <I18n data={messages.welcome_2_title} />
            </ItemTitle>
            <ItemDesc>
              <I18n data={messages.welcome_2_subtitle} />
            </ItemDesc>
          </ListItem>
          <ListItem>
            <Num>4</Num>
            <ItemTitle>
              <I18n data={messages.welcome_3_title} />
            </ItemTitle>
            <ItemDesc>
              <I18n data={messages.welcome_3_subtitle} />
            </ItemDesc>
          </ListItem>
        </List>
      ) : (
        <List>
          <ListItem>
            <Num>1</Num>
            <ItemTitle>
              <I18n data={messages.welcome_1_title} />
            </ItemTitle>
            <ItemDesc>
              <I18n data={messages.welcome_1_subtitle} />
            </ItemDesc>
          </ListItem>
          <ListItem>
            <Num>2</Num>
            <ItemTitle>
              <I18n data={messages.welcome_2_title} />
            </ItemTitle>
            <ItemDesc>
              <I18n data={messages.welcome_2_subtitle} />
            </ItemDesc>
          </ListItem>
          <ListItem>
            <Num>3</Num>
            <ItemTitle>
              <I18n data={messages.welcome_3_title} />
            </ItemTitle>
            <ItemDesc>
              <I18n data={messages.welcome_3_subtitle} />
            </ItemDesc>
          </ListItem>
        </List>
      )}
    </Content>
    <Footer>
      <CeruleanButton onClick={onClose}>
        <I18n data={messages.button_xlm_confirm} />
      </CeruleanButton>
    </Footer>
  </Wrapper>
)

export default WelcomeModal
